module.exports = __webpack_public_path__ + "img/nordea.de7dc1b.svg";